import React from 'react';
import { ToastContainer } from 'react-toastify';
import './App.css';
import Router from './router/Router';
import { AlertService } from './services/AlertService';
import { DashboardStateProvider } from './context/DashboardContext';

function refAlert(alertRef) {
  AlertService.setDropdownAlertInstance(alertRef);
}

function App() {
  return (
    <div className="App">
      <DashboardStateProvider>
        <Router />
        <ToastContainer ref={refAlert} />
      </DashboardStateProvider>
    </div>
  );
}

export default App;
